import { type NavigationItem, navigationLibs } from '@features/navigation';

export function splitNavigationLinks(links: NavigationItem[]) {
  const exploreLinks: navigationLibs.NavigationTitle[] = [
    navigationLibs.NavigationTitle.Auctions,
    navigationLibs.NavigationTitle.Artworks,
    navigationLibs.NavigationTitle.Artists,
    navigationLibs.NavigationTitle.Curators,
    navigationLibs.NavigationTitle.Selections,
  ];

  const mainLinks: navigationLibs.NavigationTitle[] = [
    navigationLibs.NavigationTitle.AboutUsUFDA,
    navigationLibs.NavigationTitle.About,
    navigationLibs.NavigationTitle.Biography,
    navigationLibs.NavigationTitle.BehindTheScenes,
    navigationLibs.NavigationTitle.FAQ,
    navigationLibs.NavigationTitle.News,
    navigationLibs.NavigationTitle.Contacts,
  ];

  const { explore, main } = links.reduce<{ explore: NavigationItem[]; main: NavigationItem[] }>(
    (acc, link) => {
      if (exploreLinks.includes(link.title)) {
        acc.explore.push(link);
      } else if (mainLinks.includes(link.title)) {
        acc.main.push(link);
      }
      return acc;
    },
    { explore: [], main: [] },
  );

  return {
    explore,
    main,
  };
}
